import RepositoryFactory from '@/repository/RepositoryFactory';

const facilityRepository = RepositoryFactory.manager.facility;

export const isBetaFacility = async (featureName: string): Promise<boolean> => {
  try {
    const response = await facilityRepository.isBetaFacility(featureName);
    return response.status === 204;
  } catch (e) {
    return false;
  }
};
